/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/
export const DocumentStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated',
    refused: 'refused'
};
export const ActionLogType = {
    creation: 'creation',
    modification: 'modification',
    deletion: 'deletion'
};
export const PrestationParticipationStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated'
};
export const TransactionStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated'
};
export const TransactionMethod = {
    bankCard: 'bankCard',
    bankTransfer: 'bankTransfer',
    check: 'check',
    cash: 'cash',
    directDebit: 'directDebit',
    ANCV: 'ANCV'
};
export const TransactionType = {
    debit: 'debit',
    credit: 'credit'
};
export const FinancialAccountType = {
    passive: 'passive',
    active: 'active',
    charge: 'charge',
    product: 'product'
};
export const UserStatus = {
    awaitingFirstConnection: 'awaitingFirstConnection',
    active: 'active',
    archived: 'archived'
};
export const AmortizationMethod = {
    linear: 'linear',
    degressive: 'degressive'
};
export const ShortcutId = {
    searchEmployee: 'searchEmployee',
    registerPayment: 'registerPayment',
    registerInvoice: 'registerInvoice',
    stockEntry: 'stockEntry',
    internalTransfer: 'internalTransfer',
    entriesList: 'entriesList',
    bankReconciliation: 'bankReconciliation',
    accountingReports: 'accountingReports',
    createParticipation: 'createParticipation'
};
export const NotificationId = {
    documentValidation: 'documentValidation',
    employeeDebts: 'employeeDebts',
    employeeCredits: 'employeeCredits',
    ticketStock: 'ticketStock',
    pendingPayments: 'pendingPayments',
    supplierInvoices: 'supplierInvoices'
};
export const PrestationPricingMode = {
    predefinedPrices: 'predefinedPrices',
    typedAmount: 'typedAmount'
};
export const PrestationType = {
    remboursement: 'remboursement',
    billetterie: 'billetterie',
    voyage: 'voyage',
    cheques: 'cheques',
    adhesion: 'adhesion'
};
export const PrestationQuestionType = {
    text: 'text',
    number: 'number',
    amount: 'amount',
    date: 'date',
    boolean: 'boolean',
    choice: 'choice'
};
export const SupplierPaymentType = {
    acompte: 'acompte',
    reglement: 'reglement'
};
export const PaymentStatus = {
    expected: 'expected',
    notDeposited: 'notDeposited',
    deposited: 'deposited',
    rejected: 'rejected',
    cancelled: 'cancelled'
};
export const PaymentDirection = {
    inflow: 'inflow',
    outflow: 'outflow'
};
export const PaymentMethodPreset = {
    chequeEncaisse: 'chequeEncaisse',
    carteEncaissee: 'carteEncaissee',
    especes: 'especes',
    decaissementBancaire: 'decaissementBancaire',
    virementAEmettre: 'virementAEmettre'
};
export const PaymentMethodBadgeColor = {
    blue: 'blue',
    green: 'green',
    orange: 'orange',
    purple: 'purple',
    red: 'red',
    gray: 'gray'
};
export const RecurrenceUnit = {
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    semester: 'semester',
    year: 'year'
};
export const JournalRole = {
    sales: 'sales',
    purchases: 'purchases',
    bank: 'bank',
    misc: 'misc',
    openingBalances: 'openingBalances'
};
export const WorkplaceStatus = {
    Active: 'Active',
    Inactive: 'Inactive'
};
export const SupplierStatus = {
    active: 'active',
    archived: 'archived'
};
export const OrderStatus = {
    pending: 'pending',
    validated: 'validated'
};
export const PaymentPeriod = {
    startOfMonth: 'startOfMonth',
    endOfMonth: 'endOfMonth',
    net: 'net'
};
export const BankReconciliationStatus = {
    open: 'open',
    closed: 'closed'
};
export const BankReconciliationEntryOrigin = {
    manual: 'manual',
    automatic: 'automatic'
};
export const AccountingPeriodStatus = {
    current: 'current',
    temporarilyClosed: 'temporarilyClosed',
    closed: 'closed'
};
export const SupplierInvoiceType = {
    invoice: 'invoice',
    credit: 'credit'
};
